import { Fragment } from 'react';

import { formatTimeForDisplay } from '@usas/ui-web/utils/TimesUtils';

import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ event, onDeleteEventClicked, showStatusColumn }) => {
  return (
    <Fragment key={event.individualAthleteMeetEventId + 'Fragment'}>
      <tr key={event.individualAthleteMeetEventId}>
        <td>{event.eventCode || ''}</td>
        <td>{event.eventCompetitionGenderTypeName || ''}</td>
        <td>{event.ageGroupName || ''}</td>
        <td>{event.meetSessionName || ''}</td>
        {showStatusColumn === true && <td>{event.status || ''}</td>}
        <td>{event.entryTime ? formatTimeForDisplay(event.entryTime) : 'NT'} {event.entryTime ? event.qualifyingCourseCode || '' : ''}</td>
        <td>{event.isAlternateEvent === true ? `ALT: ${event.qualifyingEventCode || ''}` : event.isNonConformingTime === true ? `NC: ${event.qualifyingEventCode || ''}` : `${event.qualifyingEventCode || ''}`}</td>
        <td>{event.qualifiedAsBonus === true ? 'Yes' : event.qualifiedAsBonus === false ? 'No' : ''}</td>
        <td>{event.swimTimeEntryOverride === true ? 'Yes' : event.swimTimeEntryOverride === false ? 'No' : ''}</td>
        <td>{onDeleteEventClicked && (event.hasPaid === false || event.canBeDeleted === true) && <button className={global.IconButtonMargin}
          type="button"
          onClick={(e) => onDeleteEventClicked(e, event)}>
          <DeleteIcon />
        </button>}
        </td>
      </tr>
    </Fragment>
  );
};

const OrgUnitAdminRosterEntriesDetailLargeGrid = ({ gridData, isLoading, onDeleteEventClicked, showStatusColumn }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th style={{ minWidth: '90px' }}>Event</th>
        <th style={{ minWidth: '115px' }}>Comp. Category</th>
        <th style={{ minWidth: '80px' }}>Age Group</th>
        <th>Session</th>
        {showStatusColumn === true &&
          <th>Status</th>}
        <th style={{ minWidth: '100px' }}>Entry Time</th>
        <th style={{ minWidth: '90px' }}>Time Event</th>
        <th>Bonus?</th>
        <th>Override?</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan={showStatusColumn === true ? "10" : "9"}>Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0 ?
          gridData.map((event, i) =>
            <GridRow
              key={i}
              event={event}
              onDeleteEventClicked={onDeleteEventClicked}
              showStatusColumn={showStatusColumn}
            />)
          :
          <tr>
            <td colSpan={showStatusColumn === true ? "10" : "9"}>No Individual Event Entries</td>
          </tr>
      }
    </tbody>
  </table>
);

export default OrgUnitAdminRosterEntriesDetailLargeGrid;